import { v4 as uuidv4 } from 'uuid';
import { Storage } from 'aws-amplify';

export const readHtmlFromUrl = async htmlUrl => {
	if (!htmlUrl) return '';
    try {
			const url = new URL(htmlUrl);
			if (url) {
				const fetchResponse = await fetch(htmlUrl);
				const htmlText = await fetchResponse.text();
				return htmlText;
			}
			return htmlUrl;
    } catch (error) {
			console.log('readHtmlFromUrl err:', error);
	}
};


export const handleCreateTmpPreviewHtmlCdn = async (htmlValue, htmlId) => {
	if (!htmlId) {
		htmlId = `field_${uuidv4()}`;
	}
	try {
		const s3Tmp = `assets/tmp/html/${htmlId}/preview_${uuidv4()}.html`;
		
		// Upload file to S3
		await Storage.put(s3Tmp, htmlValue, {
			contentType: 'text/html',
			level: 'public'
		});

		// Generate cdn URL
		const previewCdn = `${process.env.REACT_APP_CLOUD_FRONT_URL}/public/${s3Tmp}?v=${Date.now()}`;
		return previewCdn;
	} catch (error) {
		console.log('handleCreateTmpPreviewHtmlCdn err:', error);
	}
};
